import { render, staticRenderFns } from "./trSwitch.vue?vue&type=template&id=5b739555"
import script from "./trSwitch.vue?vue&type=script&lang=js"
export * from "./trSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports